import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, tap, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { ToastService } from 'src/app/toast/toast.service';
import {
	Site,
	EditFacilityHierarchyLevel,
	NewFacilityHierarchyLevel,
	NewFacilityHierarchyLevelName,
	EditFacilityHierarchyLevelName,
	FacilityHierarchyLevelName,
} from './sites';

@Injectable({
	providedIn: 'root',
})
export class SitesService {
	private siteUrl = environment.apiUrl + 'Sites/Names'; // URL to web api

	constructor(private http: HttpClient, public toastService: ToastService) {}

	public getSites() {
		const url = `${this.siteUrl}`;
		var ret = this.http.get<Site[]>(url);
		
		return ret;
	}

	public getSite(id: string) {
		const url = `${environment.apiUrl}Sites/${id}`;
		return this.http.get<Site>(url);
	}

	public getSiteName(id: string) {
		const url = `${environment.apiUrl}Sites/${id}/Name`;
		return this.http.get(url);
	}

	public updateSite(site: any) {
		const url = `${environment.apiUrl}Sites/${site.id}`;
		return this.http.put(url, site);
	}

	public addSite(site: any) {
		const url = `${environment.apiUrl}Sites/`;
		return this.http.post(url, site);
	}

	public removeSite(site: any) {
		const url = `${environment.apiUrl}Sites/${site.id}`;
		return this.http.delete(url, site.id);
	}

	public addFacilityHierarchyLevel(level: NewFacilityHierarchyLevel) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/`;
		return this.http.post(url, level);
	}

	public updateFacilityHierarchyLevel(level: EditFacilityHierarchyLevel) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/${level.id}`;
		return this.http.put(url, level);
	}

	public deleteFacilityHierarchyLevel(levelId: string) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/${levelId}`;
		return this.http.delete(url);
	}

	public addFacilityHierarchyLevelName(levelName: NewFacilityHierarchyLevelName) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/LevelNames`;
		return this.http.post(url, levelName);
	}

	public updateFacilityHierarchyLevelName(levelName: EditFacilityHierarchyLevelName) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/LevelNames/${levelName.id}`;
		return this.http.put(url, levelName);
	}

	public deleteFacilityHierarchyLevelName(levelNameId: string) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/LevelNames/${levelNameId}`;
		return this.http.delete(url);
	}

	public getFacilityHierarchyLevelNamesForSite(siteId: string) {
		const url = `${environment.apiUrl}FacilityHierarchyLevels/LevelNames/FromSite/${siteId}`;
		return this.http.get<FacilityHierarchyLevelName>(url);
	}

	/**
	 * Handle Http operation that failed.
	 * Let the app continue.
	 * @param operation - name of the operation that failed
	 * @param result - optional value to return as the observable result
	 */
	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			this.toastService.addMessage({ text: `${error.message}`, error: true });
			// Let the app keep running by returning an empty result.
			return of(result as T);
		};
	}
}
